import { createApp, provide } from 'vue';
import { createPinia } from 'pinia';
import _ from 'lodash';
import HioTransientParkingApp from './vue/hio-transient-parking-app/app.vue';

function InitHioTransientParking(options) {
    const pinia = createPinia();
    const app = createApp(HioTransientParkingApp);
    app.use(pinia);
    _.forEach(options, (value, key) => app.provide(key, value));

    app.mount('#HIOTransientParkingApp');
}

export { InitHioTransientParking }